import styled from '@emotion/styled';
import Item from './Item';
import Skeleton from './Skeleton';
import { ProductCardProps } from 'components/common/ProductCard';
import { invisible_scroll_bar } from 'components/products/details/styles';

interface Props {
  recent_product_list: ProductCardProps[];
  navigation: string;
  is_loading?: boolean;
}

// 최대 20개 노출
const MAX_COUNT = 20;

/**
 * 찜 > 최근 본 상품 캐러셀
 * @component
 */
const RecentProductCarousel = ({ recent_product_list, navigation, is_loading }: Props) => {
  const list = recent_product_list.slice(0, MAX_COUNT);

  if (is_loading) {
    return (
      <SC.List>
        {[...Array(10)].map((_, idx) => (
          <Skeleton key={idx} />
        ))}
      </SC.List>
    );
  }

  return (
    <SC.List>
      {list.map((item, idx) => (
        <Item key={item.catalog_product_id} navigation={navigation} product={item} index={idx} />
      ))}
    </SC.List>
  );
};

export default RecentProductCarousel;

const SC = {
  List: styled.ul`
    ${invisible_scroll_bar}

    display: flex;
    flex-wrap: nowrap;
    overflow-x: auto;
    overflow-y: hidden;

    padding: 0 16px 16px 16px;
  `,
};
